import _regeneratorRuntime from "E:/work/\u521B\u5947/\u95EE\u5377/answer-h5-new/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "E:/work/\u521B\u5947/\u95EE\u5377/answer-h5-new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { isPopCertificate } from '@/api/certificate';
export var useCertificateDialog = function useCertificateDialog() {
  var route = useRoute();
  var store = useStore();

  // 获取证书弹窗状态
  var showCertificate = ref(false);
  var getCertificateStatus = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return isPopCertificate({
              questionActiveKey: route.query.questionActiveKey,
              answerGroupKey: route.query.answerGroupKey
            }, {
              headers: {
                'CQ-MEMBER-TOKEN': store.getters.getToken
              }
            });
          case 2:
            res = _context.sent;
            if (res.ok) {
              setTimeout(function () {
                showCertificate.value = res.data;
              }, 800);
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getCertificateStatus() {
      return _ref.apply(this, arguments);
    };
  }();
  onMounted(function () {
    // 判断练习还是正式考试
    var resultType = parseInt(route.query.resultType);
    if (resultType === 1) {
      getCertificateStatus();
    }
  });

  // 监听postMessage事件
  window.addEventListener('message', function (event) {
    if (event.data === 'showCertificate') {
      showCertificate.value = true;
    }
  });
  return {
    showCertificate: showCertificate
  };
};